import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'
import { accessLevelWiseAbility } from './accessLevelWiseAbility';
import { sendMessageToParent, REACT_APP_LOGIN_PAGE, REACT_APP_SIGNUP_PAGE, clearLeadStatusArrayFromLocal } from '@utils';
import useJwt from '@src/auth/jwt/useJwt';
import jwt from 'jsonwebtoken';

import dotenv from 'dotenv';
dotenv.config();
const {
  REACT_APP_DATA_ENCRYPTION_TOKEN = 'Se!cure$me'
} = process.env;
const config = useJwt.jwtConfig

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
let userData;
const userToken = localStorage.getItem('userToken');

try {
  userData = jwt.verify(userToken, REACT_APP_DATA_ENCRYPTION_TOKEN);
} catch (error) {
  console.log('[ability.js]::error::', typeof(error), error);

  localStorage.removeItem('userData')
  localStorage.removeItem(config.storageTokenKeyName)
  localStorage.removeItem(config.storageRefreshTokenKeyName)
  localStorage.removeItem('userToken')
  localStorage.removeItem('lastApiCallTime')
  localStorage.removeItem('lastTrackTime')
  clearLeadStatusArrayFromLocal();
  sendMessageToParent({ type : "USER_LOGOUT", data : {} })

  if (![REACT_APP_LOGIN_PAGE, REACT_APP_SIGNUP_PAGE].includes(window.location.pathname)) {
    window.location.href = REACT_APP_LOGIN_PAGE;
  }
}
const existingAbility = userData ? accessLevelWiseAbility(userData) : null

export default new Ability(existingAbility || initialAbility)
